/** init domain config */
import Vue from 'vue'
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_BASE_URL
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
//单点登录地址
window._CONFIG['casPrefixUrl'] = process.env.VUE_APP_CAS_BASE_URL
window._CONFIG['onlinePreviewDomainURL'] =  process.env.VUE_APP_ONLINE_BASE_URL
window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL+ '/sys/common/pdf/pdfPreviewIframe'
window._CONFIG['frameDomainURL'] = process.env.VUE_APP_FRAME_BASE_URL
window._CONFIG['frameCADecryptURL'] = process.env.VUE_APP_CA_DECRYPT_URL
//统一CA回调地址配置
window._CONFIG['frameUnifiedCACallbackURL'] = process.env.VUE_APP_UNIFIED_CA_CALLBACK_URL
//专家电签回调地址配置
window._CONFIG['frameAppraiseCallbackURL'] = process.env.VUE_APP_APPRAISE_CALLBACK_URL
//产权竞价websocket
window._CONFIG['frameWebSocketPrURL'] = process.env.VUE_APP_WEBSOCKET_PR